<template>
    <footer class="section-footer">
        <button v-if="showButton" type="button" id="paymentbutton" class="btn" :disabled="showSpinner"
            @click="onClickSendCheckoutLink()">
            <div :class="[{'send-icon-visible': showCheckmark}]"></div>
            <div :class="['spinner', 'white-spinner', { 'spinner-visible': showSpinner }]">
                <span></span>
                <span></span>
                <span></span>
            </div>

            <template v-if="!showSpinner && !showCheckmark">
                {{resources.sendCheckoutLinkButtonText}}
            </template>
        </button>
    </footer>
</template>

<script src='./send-checkout-link-button.js'></script>
